"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const axios_1 = __importDefault(require("axios"));
const Farm_1 = __importDefault(require("../models/Farm"));
const Farm_2 = require("../models/Farm");
const GisField_1 = __importDefault(require("../models/GisField"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
const ManagementPractice_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/ManagementPractice"));
const Irrigation_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/Irrigation"));
const MetadataLibrary_1 = __importDefault(require("../models/MetadataLibrary"));
class FarmListService {
    constructor() {
        this.farms = [];
        this.currentPage = 1;
        this.nextPage = 2;
        this.farmsPerPage = 20;
        this.farmsPages = [];
        this.totalPages = 1;
        this.totalFarms = 1;
        this.loading = false;
        this.library = new MetadataLibrary_1.default();
    }
    async fetchArtificialIrrigationUsages() {
        try {
            this.loading = true;
            let url = `/irrigation-usages`;
            const response = await axios_1.default.get(url);
            return response;
        }
        catch (e) {
        }
        finally {
            this.loading = false;
        }
    }
    async fetchArtificialIrrigationTypes() {
        try {
            this.loading = true;
            let url = `/irrigation-types`;
            const response = await axios_1.default.get(url);
            return response;
        }
        catch (e) {
        }
        finally {
            this.loading = false;
        }
    }
    async fetchManagementPractices() {
        try {
            this.loading = true;
            let url = `/management-practices`;
            const response = await axios_1.default.get(url);
            return response;
        }
        catch (e) {
        }
        finally {
            this.loading = false;
        }
    }
    async fetchCrops() {
        try {
            this.loading = true;
            let url = `/crops/list`;
            const response = await axios_1.default.get(url);
            return response;
        }
        catch (e) {
        }
        finally {
            this.loading = false;
        }
    }
    async fetchLibrary() {
        var _a, _b, _c, _d;
        try {
            this.loading = true;
            const respCrops = await this.fetchCrops();
            const crops = (_a = respCrops === null || respCrops === void 0 ? void 0 : respCrops.data) === null || _a === void 0 ? void 0 : _a.map((c) => new Crop_1.default({
                id: c.id,
                name: c.crop_name,
                color: c.color,
                icon: c.logo_name
            }));
            if (crops && crops.length > 0) {
                this.library.setCrops(crops);
            }
            const respManagementPractices = await this.fetchManagementPractices();
            const managementPractices = (_b = respManagementPractices === null || respManagementPractices === void 0 ? void 0 : respManagementPractices.data) === null || _b === void 0 ? void 0 : _b.map((m) => new ManagementPractice_1.default({
                id: m.id,
                name: m.name,
                description: m.description
            }));
            if (managementPractices && managementPractices.length > 0) {
                this.library.setPractices(managementPractices);
            }
            const respArtificialTypes = await this.fetchArtificialIrrigationTypes();
            const artIrrTypes = (_c = respArtificialTypes === null || respArtificialTypes === void 0 ? void 0 : respArtificialTypes.data) === null || _c === void 0 ? void 0 : _c.map((a) => new Irrigation_1.default({
                id: a.id,
                name: a.name,
                nameESP: a.spa_name,
                nameFR: a.fr_name
            }));
            if (artIrrTypes && artIrrTypes.length > 0) {
                this.library.setArtificialIrrigationTypes(artIrrTypes);
            }
            const respArtificialUsages = await this.fetchArtificialIrrigationUsages();
            const artIrrUsages = (_d = respArtificialUsages === null || respArtificialUsages === void 0 ? void 0 : respArtificialUsages.data) === null || _d === void 0 ? void 0 : _d.map((a) => new Irrigation_1.default({
                id: a.id,
                name: a.name,
                nameESP: a.spa_name,
                nameFR: a.fr_name
            }));
            if (artIrrUsages && artIrrUsages.length > 0) {
                this.library.setArtificialIrrigationUsages(artIrrUsages);
            }
            return this.library;
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.loading = false;
        }
    }
    async fetchFarms(page, farmId = null, background = false) {
        try {
            this.loading = !background;
            this.farmsPages = [];
            if (page > this.totalPages) {
                console.warn('This page does not exist!');
            }
            else {
                let url = `/farms/api/farms?page=${page}`;
                if (farmId !== null) {
                    url += `&farm_id=${farmId}`;
                }
                const response = await axios_1.default.get(url);
                response.data.data.forEach((farm) => {
                    // const multipolygons: string[] = [];
                    const farmGisFields = [];
                    // let combinedMultipolygon = '';
                    if (farm.gis_fields_ids.length > 0) {
                        farm.gis_fields_ids.forEach((gisField) => {
                            farmGisFields.push(new GisField_1.default({
                                id: parseInt(gisField),
                                gfId: parseInt(gisField),
                                name: null !== null && null !== void 0 ? null : '',
                                geodata: '',
                                metadata: null,
                                crop: new Crop_1.default({
                                    id: 0,
                                    name: null !== null && null !== void 0 ? null : '',
                                    color: null !== null && null !== void 0 ? null : '',
                                    icon: null !== null && null !== void 0 ? null : '',
                                })
                            }));
                        });
                    }
                    else if (farm.gis_fields.length > 0) {
                        farm.gis_fields.forEach((gisField) => {
                            var _a, _b, _c, _d, _e, _f, _g;
                            farmGisFields.push(new GisField_1.default({
                                id: parseInt(gisField.id),
                                gfId: parseInt(gisField.id),
                                name: (_a = gisField.name) !== null && _a !== void 0 ? _a : '',
                                geodata: '',
                                metadata: gisField.metadata,
                                crop: new Crop_1.default({
                                    id: 0,
                                    name: (_c = (_b = gisField.crop) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '',
                                    color: (_e = (_d = gisField.crop) === null || _d === void 0 ? void 0 : _d.color) !== null && _e !== void 0 ? _e : '',
                                    icon: (_g = (_f = gisField.crop) === null || _f === void 0 ? void 0 : _f.logo) !== null && _g !== void 0 ? _g : '',
                                })
                            }));
                            /*                             if (gisField.geodata && gisField.geodata.startsWith("MULTIPOLYGON")) {
                                                            multipolygons.push(gisField.geodata);
                                                        } */
                        });
                        /*

                                                    combinedMultipolygon = multipolygons.length > 0
                                                        ? `MULTIPOLYGON(${multipolygons.map(wkt => {
                                                            const match = wkt.match(/\(\(.*\)\)/); // Extraer las coordenadas internas
                                                            if (match) {
                                                                // Eliminar el primer y último paréntesis de las coordenadas internas
                                                                return match[0].slice(1, -1);
                                                            }
                                                            return ""; // Si no coincide, devolver una cadena vacía
                                                        }).filter(coords => coords !== "").join(",")})`
                                                        : "MULTIPOLYGON(())"; // Caso de geometría vacía */
                    }
                    const farmModel = new Farm_1.default({
                        id: farm.id,
                        name: farm.name,
                        created_at: farm.created_at,
                        client_name: farm.client_name,
                        client_code: farm.client_code,
                        total_fields: farm.total_fields,
                        total_extension: farm.total_extension ? parseFloat(farm.total_extension.toFixed(2)) : 0,
                        preferred_unit: farm.preferred_unit,
                        has_results: farm.has_results,
                        eBeCrop_compatible: farm.eBeCrop_compatible,
                        eBeCrop_ready: farm.eBeCrop_ready,
                        gis_fields: farmGisFields,
                        gis_fields_ids: farm.gis_fields_ids,
                        geodata: '',
                        gis_area_id: farm.gis_area_id,
                        quote_status: farm.quote_status,
                        last_completed_project: farm.last_completed_project,
                        last_proposal: farm.last_proposal,
                        farm_crops: farm.farm_crops,
                        has_gis_area_assigned: farm.has_gis_area_assigned
                    });
                    this.farmsPages.push(farmModel);
                    this.farms.push(farmModel);
                });
                this.totalPages = response.data.meta.last_page;
                this.farmsPerPage = response.data.meta.per_page;
                this.totalFarms = response.data.meta.total;
                this.loading = false;
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    removeFarmFromModel(id) {
        this.farms = this.farms.filter((f) => f.id !== id);
        this.farmsPages = this.farmsPages.filter((f) => f.id !== id);
    }
    async removeFarm(farmId = null) {
        try {
            // this.loading = true;
            const url = `/farm/${farmId}`;
            const response = await axios_1.default.delete(url);
            if (response.status === 200) {
                if (farmId) {
                    this.removeFarmFromModel(farmId);
                }
            }
            return response;
        }
        catch (e) {
            return e.response.data;
        }
        finally {
            // this.loading = false
        }
    }
    async removeField(farmId = null, fieldId = null, gfId = null) {
        try {
            this.loading = true;
            let url = `/farm/${farmId}/field/${fieldId}/gisfield/${gfId}`;
            const response = await axios_1.default.delete(url);
            return response;
        }
        catch (e) {
            return e.response.data;
        }
        finally {
            this.loading = false;
        }
    }
    async updateField(farmId = null, field) {
        try {
            this.loading = true;
            let url = `/farm/${farmId}/field/${field.id}/gisfield/${field.gfId}`;
            const metadata = field.metadata;
            const fieldToUpdate = Object.assign({}, field);
            delete fieldToUpdate.metadata;
            let myField = Object.assign(Object.assign({}, fieldToUpdate), { crop_id: fieldToUpdate.crop.id, metadata: {
                    extension: metadata.extension || {
                        value: 0,
                        unit: ''
                    },
                    variety: metadata.variety || '',
                    density: metadata.density.value || 0,
                    uses_biodynamic_methods: metadata.practices.biodynamic_practices.enabled || false,
                    art_irrigation: metadata.practices.artificial_irrigation.enabled || false
                } });
            if (metadata.practices.artificial_irrigation.type) {
                Object.assign(myField, { irrigation_type_id: metadata.practices.artificial_irrigation.type });
            }
            if (metadata.practices.artificial_irrigation.uses) {
                Object.assign(myField, { irrigation_usage_id: metadata.practices.artificial_irrigation.uses });
            }
            if (field.metadata.practices.management_practices) {
                Object.assign(myField, { management_practices_ids: field.metadata.practices.management_practices });
            }
            if (metadata.plant_year) {
                Object.assign(myField, { plant_date: `${metadata.plant_year}-01-01` });
            }
            const response = await axios_1.default.put(url, myField);
            return response;
        }
        catch (e) {
            return e.response.data;
        }
        finally {
            this.loading = false;
        }
    }
    async fetchFarmHistory(farmId) {
        try {
            this.loading = true;
            let url = `/farm/${farmId}`;
            const response = await axios_1.default.get(url);
            const formattedResponse = new Farm_2.HistoricalFarm({
                'times': response.data.farm_fields_temps,
                'farmHistory': response.data.times.map((t) => new Farm_1.default({
                    id: response.data.farm_id,
                    name: response.data.farm_name,
                    date: t.date,
                    active: t.active,
                    has_results: t.has_results,
                    gis_fields: t.fields.map((f) => new GisField_1.default({
                        id: f.field_id,
                        name: f.gisField.name,
                        gfId: f.gisField.gis_field_id,
                        geodata: f.gisField.geodata,
                        metadata: {
                            extension: {
                                value: -1,
                                unit: '-'
                            },
                            soil_type: '',
                            plant_year: f.gisField.plant_date.split("-")[0],
                            variety: f.gisField.variety,
                            density: {
                                value: f.gisField.density,
                                unit: '-'
                            },
                            practices: {
                                artificial_irrigation: {
                                    enabled: f.gisField.art_irrigation,
                                    type: f.gisField.irrigation_type_id,
                                    uses: f.gisField.irrigation_usage_id
                                },
                                biodynamic_practices: {
                                    enabled: f.gisField.uses_biodynamic_methods
                                },
                                management_practices: f.gisField.management_practice_ids
                            }
                        },
                        crop: f.gisField.crop
                    })),
                    preferred_unit: t.unit,
                    geodata: t.geodata,
                    created_at: t.created_at,
                    client_name: t.client_name,
                    client_code: t.client_code,
                    total_fields: t.total_fields,
                    total_extension: t.total_extension,
                    has_gis_area_assigned: t.has_gis_area_assigned
                }))
            });
            return formattedResponse;
        }
        catch (e) {
            console.log(e);
        }
    }
    async editFarmName(newName, farm) {
        try {
            this.loading = true;
            let url = `/farm/${farm.id}`;
            const data = Object.assign(Object.assign({}, farm), { name: newName });
            const resp = await axios_1.default.put(url, data);
            return resp;
        }
        catch (e) {
            return e.response.data;
        }
    }
}
exports.default = FarmListService;
